import React from 'react';
import { Tag } from 'antd';
import useSubscriptionCountdown from '../hooks/useSubscriptionCountdown';
import { getSubscriptionRemainingLabel } from '../utils/subscriptionPlan';

/**
 * Live tag that stays in sync with the subscription countdown (no "1 day left" when < 24h remain).
 */
export default function SubscriptionRemainingTag({ endDate, color = 'blue' }) {
  const { remainingMs } = useSubscriptionCountdown(endDate);
  const label = getSubscriptionRemainingLabel(remainingMs);

  if (!label) {
    return null;
  }

  return (
    <Tag color={remainingMs != null && remainingMs <= 0 ? 'error' : color} style={{ margin: 0, borderRadius: 6, border: 'none' }}>
      {label}
    </Tag>
  );
}
